window._ = require('lodash');

import "./utils/axios.js";
